import { ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AuthService } from '../../services/auth-service.service';
import { UserService } from '../../services/user-service.service';

@Component({
	selector: 'app-user-actions',
	styleUrls: ['./user-action.component.scss'],
	templateUrl: './user-action.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserActionComponent implements OnInit {

	public authorizedUser: boolean;
	private positionRelativeToElement: ElementRef;

	constructor(
		public dialogRef: MatDialogRef<any>,
		public router: Router,
		public userService: UserService,
		@Inject(MAT_DIALOG_DATA) public options: { positionRelativeToElement: ElementRef, authorizedUser: boolean },
		private authService: AuthService
	) {
		this.positionRelativeToElement = options.positionRelativeToElement;
		this.authorizedUser = options.authorizedUser
	}

	public ngOnInit(): void {
		const rect: DOMRect = this.positionRelativeToElement.nativeElement.getBoundingClientRect();
		const position = { left: `${rect.x + rect.width - 270}px`, top: `${rect.y + 30}px` };
		this.dialogRef.updatePosition(position); // adjusting position
	}

	public logout(): void {
		this.authService.logout();
		this.close();
	}

	public close(): void {
		this.dialogRef.close();
	}

}
